import { render, staticRenderFns } from "./ResponsiveContentBar.vue?vue&type=template&id=988ddc9e&"
import script from "./ResponsiveContentBar.vue?vue&type=script&lang=js&"
export * from "./ResponsiveContentBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('988ddc9e')) {
      api.createRecord('988ddc9e', component.options)
    } else {
      api.reload('988ddc9e', component.options)
    }
    module.hot.accept("./ResponsiveContentBar.vue?vue&type=template&id=988ddc9e&", function () {
      api.rerender('988ddc9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/responsive/ResponsiveContentBar.vue"
export default component.exports